import React, { useEffect, useState } from 'react';
import { FaBolt, FaClock, FaCoins } from 'react-icons/fa';
import { MdOutlineSpeed } from 'react-icons/md';

const HotProductSection = ({ product, onInvest }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  if (!product) return null;

  // Styles
  const styles = {
    container: {
      margin: '20px 16px',
      background: 'linear-gradient(135deg, #1A365D 0%, #0F172A 100%)',
      borderRadius: '16px',
      overflow: 'hidden',
      position: 'relative',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
      border: '1px solid #2563EB',
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
      transition: 'opacity 0.5s ease, transform 0.5s ease'
    },
    background: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: 'radial-gradient(circle at 10% 20%, rgba(37, 99, 235, 0.1) 0%, transparent 20%), radial-gradient(circle at 90% 80%, rgba(37, 99, 235, 0.1) 0%, transparent 20%)',
      zIndex: 1
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      padding: '20px',
      position: 'relative',
      zIndex: 2
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '16px'
    },
    hotBadge: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'rgba(239, 68, 68, 0.9)',
      color: 'white',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '4px 8px',
      borderRadius: '4px',
      marginRight: '12px'
    },
    title: {
      fontSize: '22px',
      fontWeight: 'bold',
      color: '#F8FAFC',
      margin: 0
    },
    stats: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '16px',
      marginBottom: '20px'
    },
    statBox: {
      backgroundColor: 'rgba(15, 23, 42, 0.6)',
      borderRadius: '8px',
      padding: '12px',
      display: 'flex',
      alignItems: 'center'
    },
    statIcon: {
      width: '32px',
      height: '32px',
      backgroundColor: 'rgba(37, 99, 235, 0.2)',
      borderRadius: '8px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: '12px',
      color: '#60A5FA'
    },
    statContent: {
      flex: 1
    },
    statLabel: {
      fontSize: '12px',
      color: '#94A3B8',
      marginBottom: '4px'
    },
    statValue: {
      fontSize: '16px',
      fontWeight: 'bold',
      color: '#F8FAFC'
    },
    actionArea: {
      marginTop: '8px'
    },
    investButton: {
      width: '100%',
      backgroundColor: '#2563EB',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      padding: '14px',
      fontSize: '16px',
      fontWeight: 'bold',
      cursor: 'pointer',
      position: 'relative',
      overflow: 'hidden',
      transition: 'all 0.3s ease'
    },
    buttonShine: {
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)',
      animation: 'shine 2s infinite',
      pointerEvents: 'none'
    },
    imgContainer: {
      width: '100%',
      height: '200px',
      borderRadius: '8px',
      overflow: 'hidden',
      marginBottom: '16px',
      border: '1px solid rgba(37, 99, 235, 0.3)',
      position: 'relative'
    },
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(0deg, rgba(15, 23, 42, 0.7) 0%, transparent 100%)'
    },
    keyMetrics: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '16px',
      backgroundColor: 'rgba(15, 23, 42, 0.6)',
      padding: '12px',
      borderRadius: '8px'
    },
    metric: {
      textAlign: 'center'
    },
    metricValue: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#38BDF8',
      marginBottom: '4px'
    },
    metricLabel: {
      fontSize: '12px',
      color: '#94A3B8'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.background}></div>
      <div style={styles.content}>
        <div style={styles.imgContainer}>
          <img 
            src={`https://api.novasoftwaves.com${product.imageUrl}`}
            alt={product.name}
            style={styles.img}
          />
          <div style={styles.overlay}></div>
        </div>
        
        <div style={styles.header}>
          <div style={styles.hotBadge}>
            <FaBolt style={{ marginRight: '4px' }} /> FEATURED
          </div>
          <h2 style={styles.title}>{product.name}</h2>
        </div>
        
        <div style={styles.keyMetrics}>
          <div style={styles.metric}>
            <div style={styles.metricValue}>KES {product.dailyIncome}</div>
            <div style={styles.metricLabel}>Daily Yield</div>
          </div>
          <div style={styles.metric}>
            <div style={styles.metricValue}>KES {product.totalIncome}</div>
            <div style={styles.metricLabel}>Total Return</div>
          </div>
          <div style={styles.metric}>
            <div style={styles.metricValue}>KES {product.price}</div>
            <div style={styles.metricLabel}>Investment</div>
          </div>
        </div>
        
        <div style={styles.stats}>
          <div style={styles.statBox}>
            <div style={styles.statIcon}>
              <MdOutlineSpeed />
            </div>
            <div style={styles.statContent}>
              <div style={styles.statLabel}>Mining Power</div>
              <div style={styles.statValue}>High Efficiency</div>
            </div>
          </div>
          <div style={styles.statBox}>
            <div style={styles.statIcon}>
              <FaClock />
            </div>
            <div style={styles.statContent}>
              <div style={styles.statLabel}>Mining Period</div>
              <div style={styles.statValue}>{product.cycle} Days</div>
            </div>
          </div>
        </div>
        
        <div style={styles.actionArea}>
          <button
            onClick={() => onInvest(product)}
            style={styles.investButton}
            disabled={product.available < 1}
          >
            {product.available < 1 ? 'SOLD OUT' : 'START MINING NOW'}
            <span style={styles.buttonShine}></span>
          </button>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes shine {
          0% {
            left: -100%;
          }
          20% {
            left: 100%;
          }
          100% {
            left: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default HotProductSection;